<template>
  <div>
    <IncomeList title="支付宝" :pay-channel="'ALIPAY'" />
  </div>
</template>
<script>
import IncomeList from '../IncomeList'
export default {
  components: {
    IncomeList,
  },
}
</script>
